module.exports = __webpack_public_path__ + "static/media/2x5B-empty.f6af3427.svg";